import './scroll-to-top-button.scss';

import ArrowUpIcon from '@frontend/images/icons/ArrowUpIcon';


export default function ScrollToTopButton({ className = "" }) {
    const handleScrollToTop = () => {
        if (typeof window === 'undefined') return;

        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <button
            className={[
                "scrollToTopButton",
                className,
            ].filter(Boolean).join(" ")}
            type="button"
            onClick={handleScrollToTop}
            aria-label="Scroll to top"
        >
            <ArrowUpIcon />
        </button>
    );
}
